import cx from 'classnames';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import cls from './Toolbar.module.css';

export class ToolbarTitle extends PureComponent {
  static propTypes = {
    className: PropTypes.any,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  };

  render() {
    const { className, children } = this.props;

    return <div className={cx(cls.toolbarItem, cls.title, className)}>{children}</div>;
  }
}

export class ToolbarItem extends PureComponent {
  static propTypes = {
    className: PropTypes.any,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    alignRight: PropTypes.bool,
    light: PropTypes.bool,
  };

  render() {
    const { className, children, alignRight, light } = this.props;

    const classNameBundle = cx(cls.toolbarItem, { [cls.alignRight]: alignRight }, { [cls.light]: light }, className);

    if (alignRight) {
      return <span className={cx(classNameBundle, cls.alignRight)}>{children}</span>;
    }

    return <div className={classNameBundle}>{children}</div>;
  }
}

export default class extends PureComponent {
  static propTypes = {
    className: PropTypes.any,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    fixedHeight: PropTypes.bool,
  };

  static defaultProps = {
    fixedHeight: true,
  };

  static Item = ToolbarItem;

  static Title = ToolbarTitle;

  render() {
    const { className, children, fixedHeight } = this.props;

    return <nav className={cx(cls.toolbar, { [cls.fixedHeight]: fixedHeight }, className)}>{children}</nav>;
  }
}
